/**
 * Hooks Redux typés pour une meilleure expérience développeur
 */
import { useDispatch, useSelector } from "react-redux";

// Hooks typés pour utiliser dans les composants
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
